module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "font-size": "12pt"
    },
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("أفكار عشوائية")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#أنفال-السعيد"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أنفال السعيد")])])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch003#الإهداء",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الإهداء")])])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch004#حقوق-النشر",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حقوق النشر")]), _vm._v("©")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#شكر-وتقدير",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("شكر وتقدير")])])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#محتوى-الكتاب",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("محتوى الكتاب")])])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#المقدمة",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("المقدِّمة")])])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#الفصل-الأول",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الفصل الأول")])])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#الفصل-الثاني",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الفصل الثاني")])])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#الفصل-الثالث",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الفصل الثالث")])])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#الخاتمة",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الخاتمة")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0